// (function () {
// 	'use strict';
	
// 	const module = angular.module('imApp');
	
// 	module.component('purchRequestCreate', {
// 		templateUrl: 'views/components/views/purchRequestCreate/purchRequestCreate.template.html?v=' + module.version,
// 		controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'purchRequestCreateService', 'ttGridFactory', function ($stateParams, stateService, modalService, translateService, purchRequestCreateService, ttGridFactory) {
			
// 			// #region VARIABLES & DEFINITIONS
			
//             const vm = this;
// 			let purchInternalNo = $stateParams.purch_internal_no;
			
//             let translations = {
//                 error: '',
//                 ok: ''
//             };

// 			vm.model = {
// 				gridReady: false,
// 				setting: {},
// 				selectListSuppliers: [],
// 				lockedSave: false
// 			};

//             vm.grid = new ttGridFactory({
//                 rememberId: 'w_purchrequestcreate_grid',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             });
            
// 			// #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

// 			// #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.setting = (await purchRequestCreateService.getPurchRequestCreate({ purch_internal_no: purchInternalNo }))[0];
//             }
			
//             async function loadSuppliers() {
//                 vm.model.selectListSuppliers = await purchRequestCreateService.listSuppliers(vm.model.setting);
// 			}
			
// 			// #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGrid() {
//                 vm.grid.dataTask.loadData = {
//                     method: 2861,
//                     parameters: vm.model.setting
//                 };

//                 vm.model.gridReady = true;

//                 if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

// 			// #region MULTI DIRECTION BUTTON FUNCTIONS
			
// 			vm.goToFunc = function (state) {
// 				switch (state) {
// 					case 'purchhead':
//                         vm.model.lockedSave = true;

// 						purchRequestCreateService.createObj(vm.model.setting).then(function (response) {
// 							if (response[0].errorcode !== '0') {
// 								modalService.show({
// 									type: 'warning',
//                                     title: translations.error,
// 									message: response[0].errormessage,
// 									buttons: [{
//                                         label: translations.ok,
// 										cssClass: 'btn-warning',
// 										action: function (dialogItself) {
// 											dialogItself.close();
// 											vm.model.lockedSave = false;
// 										}
// 									}]
// 								});
// 							} else {
// 								vm.model.lockedSave = false;
// 								stateService.go(state, { purch_internal_no: response[0].purch_internal_no });
// 							}
// 						});
// 						break;
// 					default:
// 						break;
// 				}
// 			};
			
//             // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadSuppliers();
//                 loadGrid();
//             }

//             // #endregion ON INIT FUNCTION

// 		}]
// 	});
// })();
